function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2885 8.11475C10.2885 8.70875 10.0875 9.4865 9.7755 10.0963C9.01875 11.5813 7.47825 11.5715 7.47825 9.99125C7.47825 9.40175 7.68075 8.642 7.9935 8.05625C8.75925 6.6125 10.2885 6.83825 10.2885 8.11475ZM18 9.21875C18 14.189 13.9703 18.2188 9 18.2188C4.02975 18.2188 0 14.189 0 9.21875C0 4.2485 4.02975 0.21875 9 0.21875C13.9703 0.21875 18 4.2485 18 9.21875ZM14.25 8.32325C14.25 5.88875 12.2768 4.1225 9.558 4.1225C5.83275 4.1225 3.75 6.48425 3.75 9.42725C3.75 12.1812 5.60025 14.315 9.018 14.315C10.908 14.315 12.111 13.7705 12.8595 13.349L12.3442 12.6058C11.5778 13.0505 10.656 13.4578 9.15225 13.4578C6.5805 13.4578 4.8525 11.8085 4.8525 9.353C4.8525 5.0675 9.65325 4.2845 11.763 5.54975C13.731 6.78125 13.656 9.73325 12.1995 10.862C11.424 11.4815 10.5503 11.4613 10.8337 10.295C10.8337 10.295 11.7428 6.92825 11.8492 6.56375H10.8263L10.623 7.27775C10.4145 6.689 9.91575 6.3065 9.18975 6.3065C7.67625 6.3065 6.39825 7.949 6.39825 9.89375C6.39825 11.1912 7.083 11.9967 8.18325 11.9967C9.1455 11.9967 9.64575 11.4523 9.95625 10.967C9.73125 13.1405 14.25 12.1347 14.25 8.32325Z",
  fill: "white"
});

function SvgEmailLogoLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogoLight);
export default __webpack_public_path__ + "static/media/email-logo-light.9f8c746de29b1704cb5328868d370831.svg";
export { ForwardRef as ReactComponent };